import { Share2, Link2, Check, MessageCircle } from "lucide-react";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const PLATFORMS = [
  { id: "twitter", label: "X", color: "#000", hoverColor: "hover:bg-white/20", icon: () => <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg> },
  { id: "facebook", label: "Facebook", color: "#4267B2", hoverColor: "hover:bg-[#4267B2]/20", icon: () => <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg> },
  { id: "whatsapp", label: "WhatsApp", color: "#25D366", hoverColor: "hover:bg-[#25D366]/20", icon: () => <MessageCircle className="w-4 h-4" /> },
  { id: "reddit", label: "Reddit", color: "#FF4500", hoverColor: "hover:bg-[#FF4500]/20", icon: () => <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current"><path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z"/></svg> },
  { id: "pinterest", label: "Pinterest", color: "#E60023", hoverColor: "hover:bg-[#E60023]/20", icon: () => <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current"><path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12.017 24c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017.001z"/></svg> },
];

export const SocialShareButtons = ({ title, url, image, type = "beat", itemId = "", compact = false }) => {
  const [copied, setCopied] = useState(false);
  const shareUrl = url || window.location.href;
  const shareText = `Check out "${title}" on Gas Station!`;

  const trackShare = (platform) => {
    if (itemId) {
      axios.post(`${API}/api/sharing/track`, { item_type: type, item_id: itemId, platform }).catch(() => {});
    }
  };

  const shareLinks = {
    twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
    whatsapp: `https://wa.me/?text=${encodeURIComponent(shareText + " " + shareUrl)}`,
    reddit: `https://www.reddit.com/submit?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(title)}`,
    pinterest: `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(shareUrl)}&description=${encodeURIComponent(shareText)}${image ? "&media=" + encodeURIComponent(image) : ""}`,
  };

  const handleShare = (platform) => {
    trackShare(platform);
    window.open(shareLinks[platform], "_blank", "width=600,height=400");
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      trackShare("copy");
      toast.success("Link copied!");
      setTimeout(() => setCopied(false), 2000);
    } catch { toast.error("Failed to copy link"); }
  };

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, text: shareText, url: shareUrl });
        trackShare("native");
      } catch {}
    }
  };

  if (compact) {
    return (
      <div className="flex items-center gap-1" data-testid="social-share-buttons">
        {PLATFORMS.slice(0, 3).map(p => {
          const Icon = p.icon;
          return (
            <button key={p.id} onClick={() => handleShare(p.id)}
              className={`w-7 h-7 rounded-full bg-white/10 flex items-center justify-center text-zinc-400 ${p.hoverColor} transition`}
              data-testid={`share-${p.id}`}
            ><Icon /></button>
          );
        })}
        <button onClick={handleCopyLink}
          className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center text-zinc-400 hover:bg-neon-cyan/20 transition"
          data-testid="share-copy-link"
        >{copied ? <Check className="w-3 h-3 text-green-400" /> : <Link2 className="w-3 h-3" />}</button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="social-share-buttons">
      <span className="text-xs text-zinc-500 uppercase tracking-wide mr-1">Share</span>
      {PLATFORMS.map(p => {
        const Icon = p.icon;
        return (
          <Button key={p.id} variant="ghost" size="icon"
            className={`w-8 h-8 text-zinc-400 ${p.hoverColor}`}
            onClick={() => handleShare(p.id)}
            data-testid={`share-${p.id}`}
          ><Icon /></Button>
        );
      })}
      <Button variant="ghost" size="icon"
        className="w-8 h-8 text-zinc-400 hover:text-neon-cyan hover:bg-neon-cyan/10"
        onClick={handleCopyLink} data-testid="share-copy-link"
      >{copied ? <Check className="w-4 h-4 text-green-400" /> : <Link2 className="w-4 h-4" />}</Button>
      {navigator.share && (
        <Button variant="ghost" size="icon"
          className="w-8 h-8 text-zinc-400 hover:text-neon-magenta hover:bg-neon-magenta/10"
          onClick={handleNativeShare} data-testid="share-native"
        ><Share2 className="w-4 h-4" /></Button>
      )}
    </div>
  );
};

export default SocialShareButtons;
